import SuperRepository from '../superRepository'

export default new (class PartnerReportRepository extends SuperRepository {
  baseUri() {
    return 'partner_report'
  }
  newDeposits = async ({ signal, ...data }) =>
    this.httpClient().post(`${this.baseUri()}/new_deposit`, data, { signal })
  streamReport = async ({ signal, ...data }) =>
    this.httpClient().post(`${this.baseUri()}/stream_report`, data, { signal })
})()
